import React from "react";

export default function ProjectCheckpoints({
  checkpoints,
  isCompleted = false,
  projectPriceFinalized,
}) {
  console.log(checkpoints[0], projectPriceFinalized, "<<< chekc");

  const getMilestoneStatusLabel = status => {
    switch (status) {
      case "waiting_approval":
        return { text: "Waiting For Approval", className: "statusWaiting" };
      case "completed":
        return { text: "Completed", className: "statusCompleted" };
      case "not_completed":
      default:
        return { text: "Not Completed", className: "statusPending" };
    }
  };

  return (
    <div className="projectDetailsBox">
      <div className="projectDetailsHeader">
        {isCompleted ? "Completed Checkpoints" : "Checkpoints"}
      </div>

      {checkpoints && checkpoints.length > 0 ? (
        checkpoints.map(milestone => {
          const statusInfo = getMilestoneStatusLabel(milestone.status);
          return (
            <div className="milestoneCard" key={milestone.id}>
              <div className="milestoneHeader">
                <div className="milestoneTitle">{milestone.title}</div>
                <div
                  className={`milestoneStatus ${
                    isCompleted ? "statusCompleted" : statusInfo.className
                  }`}
                >
                  {isCompleted ? "Completed" : statusInfo.text}
                </div>
              </div>
              <div className="milestoneDescription">
                {milestone.description}
              </div>
              <div className="milestoneCompletion">
                <div className="milestoneProgressLabel">
                  Project Completion : {milestone.paymentPercentage}%
                </div>
                <div className="progressBar">
                  <div
                    className="progressFill"
                    style={{
                      width: `${milestone.paymentPercentage}%`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="milestoneAmount">
                {(
                  (parseFloat(projectPriceFinalized) *
                    parseFloat(milestone.paymentPercentage)) /
                  100
                ).toFixed(2)}{" "}
                SAR
              </div>
            </div>
          );
        })
      ) : (
        <div className="emptyState">
          {!isCompleted && (
            <img
              src={require("../../../../assets/crossIcon.png")}
              alt="No checkpoints"
              className="emptyStateImage"
            />
          )}
          <div className="emptyStateText">
            {isCompleted
              ? "No checkpoints were added for this project"
              : "No checkpoints added"}
          </div>
          {!isCompleted && (
            <div className="emptyStateStatus">
              Status : Checkpoints Not Submitted
            </div>
          )}
        </div>
      )}

      <style jsx>{`
        .projectDetailsBox {
          background: #ffffff;
          border-radius: 12px;
          padding: 24px;
          margin-top: 24px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          border: 1px solid #f0f0f0;
        }

        .projectDetailsHeader {
          font-size: 18px;
          font-weight: 600;
          color: #262626;
          margin-bottom: 24px;
          padding-bottom: 16px;
          border-bottom: 1px solid #f0f0f0;
        }

        .milestoneCard {
          background: #fff;
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 16px;
        }

        .milestoneHeader {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .milestoneTitle {
          font-size: 16px;
          font-weight: 600;
          color: #262626;
        }

        .milestoneStatus {
          padding: 4px 12px;
          border-radius: 16px;
          font-size: 14px;
          font-weight: 500;
        }

        .statusWaiting {
          background-color: #fff7e6;
          color: #fa8c16;
        }

        .statusCompleted {
          background-color: #f6ffed;
          color: #52c41a;
        }

        .statusPending {
          background-color: #f5f5f5;
          color: #8c8c8c;
        }

        .milestoneDescription {
          font-size: 14px;
          color: #595959;
          margin-bottom: 16px;
          line-height: 1.5;
        }

        .milestoneCompletion {
          margin-bottom: 12px;
        }

        .milestoneProgressLabel {
          font-size: 14px;
          color: #8c8c8c;
          margin-bottom: 8px;
        }

        .progressBar {
          height: 8px;
          background-color: #f5f5f5;
          border-radius: 4px;
          overflow: hidden;
        }

        .progressFill {
          height: 100%;
          background: linear-gradient(90deg, #1890ff 0%, #69c0ff 100%);
          border-radius: 4px;
          transition: width 0.3s ease;
        }

        .milestoneAmount {
          font-size: 16px;
          font-weight: 600;
          color: #1890ff;
        }

        .emptyState {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px;
          text-align: center;
        }

        .emptyStateImage {
          width: 64px;
          height: 64px;
          margin-bottom: 16px;
        }

        .emptyStateText {
          color: #8c8c8c;
          font-size: 16px;
          margin-bottom: 8px;
        }

        .emptyStateStatus {
          color: #6b5acd;
          font-family: Poppins, sans-serif;
          font-weight: 600;
          font-size: 14px;
        }
      `}</style>
    </div>
  );
}
